module.exports = __webpack_public_path__ + "img/next_Quest@3x.e553b4cd.png";